import { RuleResult } from '../../../types/DeclarationP5'
import { LocationOfGoods } from '../common/types'

const NC9012Validator = {
  validateAddressRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (locationOfGoods?.typeOfLocation === 'D') {
      return 'REQUIRED'
    }

    return 'NOT_ALLOWED'
  },

}

export default NC9012Validator
